<template>
    <div class="plugin-home-common-title"
         v-bind:class="{ '_has-subtitle': !!subtitle, [`_${theme}`]: true }"
         v-if="text"
    >
        <h2 v-text="text" />
        <div class="plugin-home-common-title__subtitle"
             v-if="subtitle"
             v-text="subtitle"
        />
    </div>
</template>

<script>
export default {
    name: 'plugin-home-common-title',
    props: {
        text: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        theme: {
            type: String,
            default: 'default',
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-common-title {
    h2 {
        .typography-landing-title();

        margin: 0 0 48px 0;

        text-align: center;
        text-transform: uppercase;
    }
    &._white h2 {
        color: @color-gray-lightest
    }

    &._has-subtitle h2 {
        margin-bottom: 24px;
    }

    &__subtitle {
        .typography-medium();

        margin: 0 0 48px 0;
        text-align: center;
    }

    @media @media-md-down {
        h2 {
            .typography-small();

            margin: 0 0 12px 0;

            font-weight: bold;
            text-align: left;
        }
        &._has-subtitle h2 {
            margin-bottom: 12px;
        }
        &__subtitle {
            .typography-heading();

            margin: 0 0 32px 0;

            text-align: left;
        }
    }
}
</style>
